// src/pages/Historico/utils/chartErrors.js

/**
 * Tradução dos erros de `POST /grafico`.
 *
 * O `useCharts` guardava só `e.message`, que no axios é sempre o genérico
 * "Request failed with status code 409" — a explicação real vem no CORPO
 * (`response.data.message`, montado pelo GlobalExceptionHandler) e era jogada fora.
 * O usuário via um número e uma tela vazia.
 */

/** Gráficos ainda sendo consolidados no servidor (409). Estado transitório, não falha. */
export const CODIGO_CONSOLIDANDO = 'CONSOLIDATION_PENDING';

export function interpretarErroGrafico(erro) {
    const doServidor = erro?.response?.data?.message;
    const status = erro?.response?.status;

    // O backend devolve 409 com a marca CONSOLIDATION_PENDING quando o experimento
    // está marcado como consolidado/migrado mas os artefatos consolidados ainda não
    // ficaram prontos (GraficoConsolidadoService.pending). Não é erro do usuário nem
    // da tela: é "volte daqui a pouco".
    if (status === 409 && String(doServidor || '').includes(CODIGO_CONSOLIDANDO)) {
        return {
            codigo: CODIGO_CONSOLIDANDO,
            mensagem:
                'Os gráficos deste experimento estão sendo consolidados no servidor. ' +
                'Isso costuma levar alguns minutos — tente novamente em instantes.',
        };
    }

    return {
        codigo: null,
        mensagem:
            doServidor ||
            erro?.message ||
            'Não foi possível carregar este gráfico.',
    };
}
